export default __webpack_public_path__ + "static/media/template2.b3ed7921.svg";